goog.provide("shadow.js.shim.module$$mui$material$Step$default");
shadow.js.shim.module$$mui$material$Step$default = shadow.js.shim.module$$mui$material$Step.default;
